import { createFileRoute } from '@tanstack/react-router';
import Device from 'src/components/device/Device';

export const Route = createFileRoute('/device')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/device"! <Device/></div>;
}